module.exports = __webpack_public_path__ + "img/nf-top.38eda633.jpg";